export const SSG_VERSION = '1.0.2';
